// extracted by mini-css-extract-plugin
export default {"__container":"staticPages___container__Y0a5v","__head":"staticPages___head__HCYaI","__section":"staticPages___section__3EHsP"};